






















import {Component, Prop, Vue} from 'vue-property-decorator';
import {WebService} from '@/services/web.service';
import {OverlayShowTime} from '@/constants';


@Component({
	components: {
	}
})
export default class SendAccessSMS extends Vue {
	phoneNumber = '';
	phoneNumberFocused = false;
	showLoading = false;
	showCompletedOverlay = false;
	overlayMessage = '';

	mounted() {
		this.$nextTick(() => {
			this.phoneNumberFocused = true;
		});
	}

	async send() {
		if(this.phoneNumber.length !== 10 && this.phoneNumber.length !== 11) {
			await this.$bvModal.msgBoxOk('You must enter a valid phone number', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
			return false;
		}
		try {
			this.showLoading = true;
			await WebService.sendSmsAuth(this.phoneNumber);
			this.showLoading = false;
			this.overlayMessage = `SMS Sent!`;
			this.showCompletedOverlay = true;
			setTimeout(() => {
				this.showCompletedOverlay = false;
				this.phoneNumber = '';
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem sending the SMS', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}
}
